import React from 'react';

import { FormattedMessage } from 'react-intl';
import { call, put, CallEffect, PutEffect } from 'redux-saga/effects';

import { getConversionToolColumns } from '@api/mapping';
import { conversionToolColumnsGetModel } from '@models/ConversionTool/conversionToolColumnsGet';
import type { Column } from '@models/ConversionTool/conversionToolColumnsGet/types';
import {
  conversionToolColumnsFetchFailure,
  conversionToolColumnsFetchSuccess,
} from '@store/conversionTool/conversionToolColumns/conversionToolColumns.actions';
import type { SagaPayloadAction } from '@store/types';

export const conversionToolColumnsFetchSaga = function* ({
  payload = {},
}: SagaPayloadAction<{ filingTypeId?: string; registrationId?: string }>): Generator<
  CallEffect<{ columns: Array<Column> }> | PutEffect,
  void,
  { columns: Array<Column> }
> {
  try {
    const response = yield call(getConversionToolColumns, {
      filingTypeId: payload?.filingTypeId,
      registrationId: payload?.registrationId,
    });

    yield put(conversionToolColumnsFetchSuccess(conversionToolColumnsGetModel(response.columns)));
  } catch (errors) {
    const { nonFieldErrors } = errors?.data || {};

    yield put(
      conversionToolColumnsFetchFailure(
        nonFieldErrors || (
          <FormattedMessage
            defaultMessage="An error occurred while initialising the conversion tool."
            id="global.notification.api-error-conversion-tool"
          />
        )
      )
    );
  }
};
